import { TECHNICAL_INVENTORY } from './../../Data/inventoryProvider';
import TechnicalTable from './../../Shared/Components/table/TechnicalTable';

const TechnicalDataPage = () => {
  return (
    <div className="page-wrapper" style={{ padding: '40px' }}>
      <TechnicalTable data={TECHNICAL_INVENTORY.mainSpecs} />

      {TECHNICAL_INVENTORY.compatibility.tables.map((table, idx) => (
        <TechnicalTable 
          key={idx} 
          data={{ title: idx === 0 ? TECHNICAL_INVENTORY.compatibility.title : "", ...table }} 
          variant="secondary"
        />
      ))}
    </div>
  );
};

export default TechnicalDataPage;   